import React from "react";
import "./App.scss";
import { Route, Routes } from "react-router-dom";
import { Amplify } from "aws-amplify";
import { useAuthenticator } from "@aws-amplify/ui-react";

import ListView from "./pages/ListView";
import ItemDetailedView from "./pages/ItemDetailedView";
import NavBar from "./components/NavBar";
import ErrorView from "./pages/ErrorView";
import SignInView from "./pages/SignInView";
import QueueVolumeView from "./pages/QueueVolumeView";

Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID ?? "",
      userPoolClientId: process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID ?? "",
    },
  },
});

function App() {
  const { authStatus } = useAuthenticator(context => [context.authStatus]);

  return (
    <div className="h-100 d-flex flex-column">
      {authStatus === "unauthenticated"
        ? <SignInView />
        : authStatus === "authenticated" && (
          <>
            <header>
              <NavBar />
            </header>
            <main className="flex-grow-1">
              <Routes>
                <Route path="/" element={<ListView />} />
                <Route path="asset/:id" element={<ItemDetailedView />} />
                <Route path="queues" element={<QueueVolumeView />} />
                <Route
                  path="error"
                  element={
                    <ErrorView hasHomeButton={true} message="Something went wrong" />
                  }
                />
              </Routes>
            </main>
          </>
        )}
    </div>
  );
}

export default App;
